




















import { Vue, Component, Mixins } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  ei: any = {};

  option: any = {
    title: {},
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c}%"
    },
    toolbox: {
      feature: {
        dataView: { readOnly: false },
        restore: {},
        saveAsImage: {}
      }
    },
    legend: {
      data: ["新注册馆长", "创建场馆", "申请激活AI机器人", "激活成功", "导入通讯录球友", "分享微信"]
    },

    series: [
      {
        name: "漏斗图",
        type: "funnel",
        left: "10%",
        top: 60,
        //x2: 80,
        bottom: 60,
        width: "80%",
        // height: {totalHeight} - y - y2,
        min: 0,
        max: 100,
        minSize: "0%",
        maxSize: "100%",
        sort: "descending",
        gap: 2,
        label: {
          show: true,
          position: "inside"
        },
        labelLine: {
          length: 10,
          lineStyle: {
            width: 1,
            type: "solid"
          }
        },
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 1
        },
        emphasis: {
          label: {
            fontSize: 20
          }
        },
        data: [
          { value: 5, name: "分享微信" },
          { value: 10, name: "导入通讯录球友" },
          { value: 20, name: "激活成功" },
          { value: 35, name: "申请激活AI机器人" },
          { value: 70, name: "创建场馆" },
          { value: 100, name: "新注册馆长" }
        ]
      }
    ]
  };
}
